import { useCallback } from 'react'
import { Params, Filters, useQueryWithParams } from 'hooks/useQueryWithParams'
import { FIND_ALL_USER_BLOCK_HISTORY } from 'queries/users'
import { findAllUserBlockHistory, findAllUserBlockHistoryVariables } from '__generatedTypes__/findAllUserBlockHistory'

export const castParams =
  (userId: string) =>
  ({ page, take }: Params<Filters>): findAllUserBlockHistoryVariables => ({
    query: {
      skip: (page - 1) * take,
      take,
      where: {
        user: {
          id: userId,
        },
      },
    },
  })

export function useWarningHistory(userId: string) {
  const castParamsCb = useCallback(castParams(userId), [userId])

  return useQueryWithParams<
    findAllUserBlockHistory,
    findAllUserBlockHistoryVariables,
    'findAllUserBlockHistory',
    'items',
    'count'
  >(FIND_ALL_USER_BLOCK_HISTORY, 'findAllUserBlockHistory', 'items', 'count', castParamsCb, undefined, {
    fetchPolicy: 'network-only',
  })
}
